import React, { useState } from 'react';
import PersonnelTransferModal from './PersonnelTransferModal';
import { Button } from '../ui-kit';
import { IconArrowRight } from '../ui-kit/icons.js';

const StartButton = ({ userId, groupIds, schedulableGroupIds, personnelTransferId = null, label = null }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  label = label || I18n.t('schedules.exchanges.personnel_transfer.button_title');

  return (
    <>
      <Button variant="secondary" onClick={handleShow} size="sm">
        <IconArrowRight /> {label}
      </Button>
      {show && (
        <PersonnelTransferModal
          onHide={handleClose}
          userId={userId}
          groupIds={groupIds}
          personnelTransferId={personnelTransferId}
          schedulableGroupIds={schedulableGroupIds}
        />
      )}
    </>
  );
};

export default StartButton;
